import { HSCCard, HSCIconAndLabel } from 'Components';
import { AppContentView } from 'Components/AppLayout';

const Dashboard = () => {
  let dashboardContent = (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <HSCCard>
        <div style={{ display: 'flex', gap: 12 }}>
          <HSCIconAndLabel large icon={'cog'} title={'Under Construction'} />
          <HSCIconAndLabel large icon={'cog'} />
        </div>
      </HSCCard>
      <HSCCard>
        <HSCIconAndLabel icon={'information'} title={'Widget Ideas:'} />
        <div
          style={{
            paddingTop: 16,
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
          }}>
          <HSCIconAndLabel small icon={'pin'} title={'News items'} />
          <HSCIconAndLabel small icon={'help'} title={'Help'} />
          <HSCIconAndLabel
            small
            icon={'grid'}
            title={'Quick link to orders to be picked up'}
          />
          <HSCIconAndLabel
            small
            icon={'grid'}
            title={
              "List of notes on requests that I'm the buyer or requester for"
            }
          />
          <HSCIconAndLabel
            small
            icon={'grid'}
            title={"Quick link to 'my orders'"}
          />
          <HSCIconAndLabel
            small
            icon={'grid'}
            title={'For approvers: orders needing my approval'}
          />
        </div>
      </HSCCard>
    </div>
  );

  return (
    <AppContentView hideBreadcrumbs title=''>
      {dashboardContent}
    </AppContentView>
  );
};

export default Dashboard;
